import { InvoiceDueDateSubsegment } from "@common/types/invoice";

interface InvoiceDueDateBucketRange {
    isOverdue: boolean;
    minOverdue: number | undefined;
    maxOverdue: number | undefined;
}

export interface InvoiceDueDateFilters {
    overdue: boolean | undefined;
    minOverdue: number | undefined;
    maxOverdue: number | undefined;
}

const INVOICE_DUE_DATE_BUCKET_RANGES: Record<
    InvoiceDueDateSubsegment,
    InvoiceDueDateBucketRange
> = {
    [InvoiceDueDateSubsegment.CURRENT]: {
        isOverdue: false,
        minOverdue: undefined,
        maxOverdue: undefined,
    },
    [InvoiceDueDateSubsegment.PAST_DUE_1_TO_30]: {
        isOverdue: true,
        minOverdue: 1,
        maxOverdue: 30,
    },
    [InvoiceDueDateSubsegment.PAST_DUE_31_TO_60]: {
        isOverdue: true,
        minOverdue: 31,
        maxOverdue: 60,
    },
    [InvoiceDueDateSubsegment.PAST_DUE_61_TO_90]: {
        isOverdue: true,
        minOverdue: 61,
        maxOverdue: 90,
    },
    [InvoiceDueDateSubsegment.PAST_DUE_91_PLUS]: {
        isOverdue: true,
        minOverdue: 91,
        maxOverdue: undefined,
    },
};

export const INVOICE_DUE_DATE_BUCKET_ORDER = [
    InvoiceDueDateSubsegment.CURRENT,
    InvoiceDueDateSubsegment.PAST_DUE_1_TO_30,
    InvoiceDueDateSubsegment.PAST_DUE_31_TO_60,
    InvoiceDueDateSubsegment.PAST_DUE_61_TO_90,
    InvoiceDueDateSubsegment.PAST_DUE_91_PLUS,
];

export const getInvoiceDueDateBucketFilters = (
    bucket: InvoiceDueDateSubsegment,
): InvoiceDueDateFilters => {
    const { isOverdue, minOverdue, maxOverdue } =
        INVOICE_DUE_DATE_BUCKET_RANGES[bucket];
    return { overdue: isOverdue, minOverdue, maxOverdue };
};

/** Returns the bucket whose range exactly matches the filters, if any. */
export const findInvoiceDueDateBucket = ({
    overdue,
    minOverdue,
    maxOverdue,
}: Partial<InvoiceDueDateFilters>): InvoiceDueDateSubsegment | null =>
    INVOICE_DUE_DATE_BUCKET_ORDER.find((bucket) => {
        const range = INVOICE_DUE_DATE_BUCKET_RANGES[bucket];
        return (
            range.isOverdue === overdue &&
            range.minOverdue === minOverdue &&
            range.maxOverdue === maxOverdue
        );
    }) ?? null;
